import { ReactNode } from 'react';
import { useSubdomain } from '@/hooks/useSubdomain';
import CoachWebsite from '@/pages/CoachWebsite';

interface SubdomainRouterProps {
  children: ReactNode;
}

/**
 * SubdomainRouter checks if the current URL is a coach subdomain.
 * If it is, it renders the coach's website.
 * Otherwise, it renders the platform routes (children).
 */
const SubdomainRouter = ({ children }: SubdomainRouterProps) => {
  const { isSubdomain, isLoading, coachId } = useSubdomain();

  // While checking subdomain, show loading
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <div className="w-10 h-10 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-3" />
          <p className="text-sm text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  // If it's a coach subdomain, render their website
  if (isSubdomain && coachId) {
    return <CoachWebsite />;
  }

  // Otherwise, render normal platform routes
  return <>{children}</>;
};

export default SubdomainRouter;
